import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";

import * as C from "components/EntityCard/styles";
import { SecretaryBody } from "types/secrataries";

interface SecretaryCardInterface {
  setModal: () => void;
  disableSecretary: (id: number) => void;
  secretary: SecretaryBody;
}

const getInitials = (name: string) => {
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const SecretaryCard = ({
  secretary,
  setModal,
  disableSecretary,
}: SecretaryCardInterface) => {
  const {
    id,
    name,
    socialName,
    cpf,
    email,
    phone,
    mobilePhone,
    addressRoad,
    addressNumber,
    addressCity,
    addressState,
  } = secretary;

  const displayName = socialName?.length ? `${socialName} (${name})` : name;
  const address = addressRoad
    ? `${addressRoad}, ${addressNumber}, ${addressCity} - ${addressState}`
    : null;

  return (
    <C.Card
      style={{ "--left-color": "var(--primary)" } as React.CSSProperties}
      aria-label={`Secretária: ${displayName}`}
    >
      <C.CardHeader>
        <C.AvatarCircle aria-hidden="true">{getInitials(name)}</C.AvatarCircle>

        <OverlayTrigger placement="top" overlay={<Tooltip>{displayName}</Tooltip>}>
          <C.EntityName>{displayName}</C.EntityName>
        </OverlayTrigger>

        <C.StatusBadge $active aria-label="Status: Ativo">
          <i className="uil uil-check-circle" aria-hidden="true" />
          Ativo
        </C.StatusBadge>

        <Dropdown align="end">
          <Dropdown.Toggle as="div" bsPrefix="no-caret">
            <C.ActionButton aria-label={`Ações para ${displayName}`} aria-haspopup="true">
              <i className="uil uil-ellipsis-v" aria-hidden="true" />
            </C.ActionButton>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item as="button" onClick={setModal}>
              <i className="uil uil-edit-alt me-2" aria-hidden="true" />
              Editar
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              as="button"
              className="text-danger"
              onClick={() => disableSecretary(id)}
            >
              <i className="uil uil-trash me-2" aria-hidden="true" />
              Excluir
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </C.CardHeader>

      <C.CardBody aria-label="Dados da secretária">
        <C.MetaItem>
          <C.MetaLabel>CPF</C.MetaLabel>
          <C.MetaValue>{cpf}</C.MetaValue>
        </C.MetaItem>

        <C.MetaItem>
          <C.MetaLabel>E-mail</C.MetaLabel>
          <OverlayTrigger placement="top" overlay={<Tooltip>{email}</Tooltip>}>
            <C.MetaValue>{email || "—"}</C.MetaValue>
          </OverlayTrigger>
        </C.MetaItem>

        <C.MetaItem>
          <C.MetaLabel>Telefone</C.MetaLabel>
          <C.MetaValueStack>
            {phone && <span>{phone}</span>}
            {mobilePhone && <small>{mobilePhone}</small>}
            {!phone && !mobilePhone && <C.MetaValueMuted>—</C.MetaValueMuted>}
          </C.MetaValueStack>
        </C.MetaItem>

        <C.MetaItem>
          <C.MetaLabel>Endereço</C.MetaLabel>
          {address ? (
            <OverlayTrigger placement="top" overlay={<Tooltip>{address}</Tooltip>}>
              <C.MetaValue>{address}</C.MetaValue>
            </OverlayTrigger>
          ) : (
            <C.MetaValueMuted>Não informado</C.MetaValueMuted>
          )}
        </C.MetaItem>
      </C.CardBody>
    </C.Card>
  );
};

export default SecretaryCard;
